/* UKL — Menu mobile en panneau flottant.
   Ajoute au tiroir du thème : en-tête (marque, accroche, bouton accueil), recherche,
   raccourcis en pilules, titres de rubriques, icônes, et range les pages d'aide
   (/pages/...) dans une rubrique « Aide ». Les liens viennent du menu Shopify.
   « Tout voir » ouvre /collections?view=rayons (templates/list-collections.rayons.json) :
   Chaussures, Doudounes & Vestes et Vêtements sur une seule page. */
(function () {
  var cfg = window.UKL_MENU || {};

  var TEXTS = {
    fr: { tagline: 'Lifestyle, sneakers & streetwear.', search: 'Rechercher une paire…', home: 'Accueil', shop: 'Boutique', help: 'Aide', pills: ['Sneakers', 'Doudounes', 'Tout voir'] },
    en: { tagline: 'Lifestyle, sneakers & streetwear.', search: 'Search for a pair…', home: 'Home', shop: 'Shop', help: 'Help', pills: ['Sneakers', 'Puffers', 'Shop all'] },
    nl: { tagline: 'Lifestyle, sneakers & streetwear.', search: 'Zoek een paar…', home: 'Home', shop: 'Shop', help: 'Hulp', pills: ['Sneakers', 'Donsjassen', 'Alles bekijken'] }
  };
  var t = TEXTS[cfg.locale] || TEXTS.fr;

  var ICONS = {
    shoe: '<path d="M2.5 17v-4.2l3.6-.9 2.9-3.9 2.3.6-.6 2.4 3.1 2 5.6 1.4c1 .3 1.6 1.1 1.6 2.1V17z"/><path d="M2.5 19.5h19"/><path d="M11 13.4l1.1-1.5M13.3 14.2l1.1-1.5"/>',
    jacket: '<path d="M8.5 3.5 4.5 5.5 3 10v9.5h4.5"/><path d="M15.5 3.5 19.5 5.5 21 10v9.5h-4.5"/><path d="M8.5 3.5c.8 1.1 2 1.7 3.5 1.7s2.7-.6 3.5-1.7"/><path d="M7.5 9v11.5h9V9M12 5.2v15.3M7.5 12h9M7.5 16h9"/>',
    hoodie: '<path d="M8 3.5 3.5 6.5l2 4 2-1v11h9v-11l2 1 2-4L16 3.5c-.6 1.4-2.2 2.3-4 2.3s-3.4-.9-4-2.3z"/>',
    sock: '<path d="M9 3h6v8.5l-3.6 6.2a3 3 0 0 1-5.2-3L9 10z"/><path d="M9 6.5h6"/>',
    truck: '<path d="M3 6.5h11v9H3zM14 9.5h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/>',
    help: '<circle cx="12" cy="12" r="9"/><path d="M9.6 9.3a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2.1-2.4 3.6"/><path d="M12 17h.01"/>',
    bag: '<path d="M5 8h14l-1 12H6z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/>',
    home: '<path d="M3.5 11 12 4l8.5 7"/><path d="M6 9.5V20h12V9.5"/><path d="M10 20v-5h4v5"/>',
    search: '<circle cx="11" cy="11" r="6.5"/><path d="m16 16 4 4"/>'
  };

  function svg(name) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS[name] + '</svg>';
  }

  function iconFor(href) {
    href = (href || '').toLowerCase();
    if (/chaussure|sneaker|shoe/.test(href)) return 'shoe';
    if (/doudoune|veste|gilet|jacket/.test(href)) return 'jacket';
    if (/vetement|clothing/.test(href)) return 'hoodie';
    if (/lacet|chaussette|sock/.test(href)) return 'sock';
    if (/suivre|commande|track|order/.test(href)) return 'truck';
    if (/faq|f-a-q|contact|aide|help/.test(href)) return 'help';
    return 'bag';
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function addIcon(li) {
    var a = li.querySelector(':scope > .m-menu-mobile__link');
    if (!a || a.querySelector('.ukl-mn__ico')) return;
    var ico = document.createElement('span');
    ico.className = 'ukl-mn__ico';
    ico.innerHTML = svg(iconFor(a.getAttribute('href')));
    a.insertBefore(ico, a.firstChild);
  }

  function build() {
    var drawer = document.getElementById('m-menu-drawer');
    if (!drawer || drawer.getAttribute('data-ukl-menu')) return;
    var content = drawer.querySelector('.m-menu-drawer__content');
    var nav = drawer.querySelector('.m-menu-drawer__navigation');
    if (!content || !nav) return;
    drawer.setAttribute('data-ukl-menu', '1');
    drawer.classList.add('ukl-mn');

    var col = (cfg.collections || '/collections').replace(/\/$/, '');
    var pills = [
      { label: t.pills[0], href: col + '/chaussures', solid: true },
      { label: t.pills[1], href: col + '/doudounes-gilets', solid: true },
      { label: t.pills[2], href: col + '?view=rayons', solid: false }
    ];

    var top = document.createElement('div');
    top.className = 'ukl-mn__top';
    top.innerHTML =
      '<div class="ukl-mn__head">' +
        '<div>' +
          '<p class="ukl-mn__brand">Urban <span class="ukl-mn__brush">Kicklab</span></p>' +
          '<p class="ukl-mn__tag">' + esc(t.tagline) + '</p>' +
        '</div>' +
        '<a class="ukl-mn__home" href="' + esc(cfg.home || '/') + '" aria-label="' + esc(t.home) + '">' + svg('home') + '</a>' +
      '</div>' +
      '<form class="ukl-mn__search" action="' + esc(cfg.search || '/search') + '" method="get" role="search">' +
        svg('search') +
        '<input type="search" name="q" placeholder="' + esc(t.search) + '" aria-label="' + esc(t.search) + '" autocomplete="off">' +
        '<input type="hidden" name="options[prefix]" value="last">' +
      '</form>' +
      '<div class="ukl-mn__pills">' +
        pills.map(function (p) {
          return '<a class="ukl-mn__pill' + (p.solid ? ' is-solid' : '') + '" href="' + esc(p.href) + '">' + esc(p.label) + '</a>';
        }).join('') +
      '</div>';
    content.insertBefore(top, content.firstChild);

    var shopLabel = document.createElement('p');
    shopLabel.className = 'ukl-mn__label';
    shopLabel.textContent = t.shop;
    content.insertBefore(shopLabel, nav);

    var helpItems = [].filter.call(nav.children, function (li) {
      var a = li.querySelector(':scope > .m-menu-mobile__link');
      return a && /\/pages\//.test(a.getAttribute('href') || '');
    });
    if (helpItems.length) {
      var helpLabel = document.createElement('p');
      helpLabel.className = 'ukl-mn__label ukl-mn__label--help';
      helpLabel.textContent = t.help;
      var helpList = document.createElement('ul');
      helpList.className = 'ukl-mn__help';
      helpItems.forEach(function (li) { helpList.appendChild(li); });
      nav.parentNode.insertBefore(helpLabel, nav.nextSibling);
      helpLabel.parentNode.insertBefore(helpList, helpLabel.nextSibling);
      helpItems.forEach(addIcon);
    }

    [].forEach.call(nav.children, addIcon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
